var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    stroke: "#3899ec",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    width: 21,
    height: 21,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 6l6 6-6 6"
  })));
}

export default "data:image/svg+xml,%3csvg fill='none' stroke='%233899ec' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' width='21px' height='21px' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' %3e %3cpath d='M0 0h24v24H0z' stroke='none'%3e%3c/path%3e %3cpath d='M9 6L15 12 9 18'%3e%3c/path%3e %3c/svg%3e";
export { SvgArrowIcon as ReactComponent };